import { useEffect, useState } from 'react';
import { getInfoMapDataByShopId, ResponseData } from '../../module/services/getInfoMapDataByShopId';
import { useWindowSizing } from '@hooks/useSizeWindow';
import { LinkTheme, MyLink, SkeletonLoading } from '@app/shared';
import classNames from 'classnames';
import IconGeo from './icons/geo.svg';

import styles from './BuildRoute.module.scss';

export const BuildRoute = ({ shopId, className }: { shopId: number; className?: string }) => {
  const isMobile = useWindowSizing(990);
  const [data, setData] = useState<ResponseData>(null);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  useEffect(() => {
    if (!isLoaded && shopId) {
      getInfoMapDataByShopId(shopId).then(res => {
        setData(res);
        setIsLoaded(true);
      });
    }
  }, []);

  if (!isLoaded && !data) {
    return <SkeletonLoading width={'100px'} height={'20px'} />;
  }

  if (!data?.yandexMapUrl && isLoaded) {
    return null;
  }

  if (isMobile) {
    return (
      <div className={classNames(styles.Wrapper, className)}>
        <MyLink href={data?.yandexMapUrl || ''}>Построить маршрут</MyLink>
      </div>
    );
  }

  return (
    <div className={classNames(styles.Wrapper, className)}>
      <MyLink id="link-orders-build-route" target={'_blank'} themes={LinkTheme.Theme1} href={data?.yandexMapUrl || ''}>
        <IconGeo />
        Как доехать
      </MyLink>
    </div>
  );
};
